/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiAddItemToCollectionRequestDto,
  ApiAddItemToCollectionResponseDto,
  ApiAddItemsToCollectionRequestDto,
  ApiAddItemsToCollectionResponseDto,
  ApiAttachmentsInboxRequestDto,
  ApiChangeItemInCollectionRequestDto,
  ApiChangeItemInCollectionResponseDto,
  ApiCollectionDto,
  ApiPushCollectionDto,
  ApiRemoveItemInCollectionRequestDto,
  ApiRemoveItemInCollectionResponseDto,
  ApiRemoveItemsFromCollectionRequestDto,
  ApiRemoveItemsFromCollectionResponseDto,
  ApiUpdateItemsInCollectionRequestDto,
  ApiUpdateItemsInCollectionResponseDto,
  ApiUpdateManyCollectionsRequestDto,
  ApiUpdateManyCollectionsResponseDto,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class Synchronizer<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * @description Use synchronizer/collections/item/add and other methods instead.
   *
   * @tags Synchronizer
   * @name SynchronizerControllerPushCollection
   * @summary Push collection. Use synchronizer/collections/item/add and other methods instead.
   * @request POST:/synchronizer/collections
   * @deprecated
   * @secure
   * @response `201` `void` Collection has been successfully pushed
   * @response `403` `void` Unauthorized or forbidden to add the collection.
   */
  synchronizerControllerPushCollection = (
    data: ApiPushCollectionDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/synchronizer/collections`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Synchronizer
   * @name SynchronizerControllerPullCollections
   * @summary Retrieve all collections
   * @request GET:/synchronizer/collections
   * @secure
   * @response `200` `(ApiCollectionDto)[]` List of collections successfully retrieved.
   * @response `403` `void` Unauthorized access to collections.
   */
  synchronizerControllerPullCollections = (params: RequestParams = {}) =>
    this.request<ApiCollectionDto[], ApiBaseError>({
      path: `/synchronizer/collections`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Synchronizer
   * @name SynchronizerControllerPullCollection
   * @summary Retrieve a specific collection by name
   * @request GET:/synchronizer/collections/{name}
   * @secure
   * @response `200` `ApiCollectionDto` Specific collection retrieved successfully.
   * @response `403` `void` Unauthorized access to the specific collection.
   * @response `404` `void` Collection not found with the given name.
   */
  synchronizerControllerPullCollection = (
    name: string,
    params: RequestParams = {},
  ) =>
    this.request<ApiCollectionDto, ApiBaseError>({
      path: `/synchronizer/collections/${name}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Synchronizer
   * @name SynchronizerControllerAddItem
   * @summary Add a new item to the specified collection
   * @request POST:/synchronizer/collections/item/add
   * @secure
   * @response `201` `ApiAddItemToCollectionResponseDto` Item has been successfully added.
   */
  synchronizerControllerAddItem = (
    data: ApiAddItemToCollectionRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiAddItemToCollectionResponseDto, ApiBaseError>({
      path: `/synchronizer/collections/item/add`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Synchronizer
   * @name SynchronizerControllerChangeItem
   * @summary Change an existing item in the specified collection
   * @request POST:/synchronizer/collections/item/change
   * @secure
   * @response `200` `ApiChangeItemInCollectionResponseDto` Item has been successfully changed.
   */
  synchronizerControllerChangeItem = (
    data: ApiChangeItemInCollectionRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiChangeItemInCollectionResponseDto, ApiBaseError>({
      path: `/synchronizer/collections/item/change`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Synchronizer
   * @name SynchronizerControllerRemoveItem
   * @summary Remove an existing item from the specified collection
   * @request POST:/synchronizer/collections/item/remove
   * @secure
   * @response `200` `ApiRemoveItemInCollectionResponseDto` Item has been successfully removed.
   */
  synchronizerControllerRemoveItem = (
    data: ApiRemoveItemInCollectionRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiRemoveItemInCollectionResponseDto, ApiBaseError>({
      path: `/synchronizer/collections/item/remove`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Synchronizer
   * @name SynchronizerControllerRemoveItems
   * @summary Remove multiple items from the specified collection
   * @request POST:/synchronizer/collections/item/removeMany
   * @secure
   * @response `200` `ApiRemoveItemsFromCollectionResponseDto` Items have been successfully removed.
   */
  synchronizerControllerRemoveItems = (
    data: ApiRemoveItemsFromCollectionRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiRemoveItemsFromCollectionResponseDto, ApiBaseError>({
      path: `/synchronizer/collections/item/removeMany`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Synchronizer
   * @name SynchronizerControllerAddItems
   * @summary Add multiple items to the specified collection
   * @request POST:/synchronizer/collections/item/addMany
   * @secure
   * @response `201` `ApiAddItemsToCollectionResponseDto` Items have been successfully added.
   */
  synchronizerControllerAddItems = (
    data: ApiAddItemsToCollectionRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiAddItemsToCollectionResponseDto, ApiBaseError>({
      path: `/synchronizer/collections/item/addMany`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Synchronizer
   * @name SynchronizerControllerUpdateItems
   * @summary Update multiple items in the specified collection
   * @request POST:/synchronizer/collections/item/changeMany
   * @secure
   * @response `200` `ApiUpdateItemsInCollectionResponseDto` Items have been successfully updated.
   */
  synchronizerControllerUpdateItems = (
    data: ApiUpdateItemsInCollectionRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiUpdateItemsInCollectionResponseDto, ApiBaseError>({
      path: `/synchronizer/collections/item/changeMany`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Synchronizer
   * @name SynchronizerControllerRemoveAttachFomInbox
   * @summary Add an attachment from the specified collection
   * @request POST:/synchronizer/collections/files/add
   * @secure
   * @response `200` `boolean` Files has been successfully attached.
   */
  synchronizerControllerRemoveAttachFomInbox = (
    data: ApiAttachmentsInboxRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<boolean, ApiBaseError>({
      path: `/synchronizer/collections/files/add`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Synchronizer
   * @name SynchronizerControllerUpdateManyCollections
   * @summary Update multiple collections at once
   * @request POST:/synchronizer/collections/collections/updateMany
   * @secure
   * @response `200` `ApiUpdateManyCollectionsResponseDto` Collections have been successfully updated.
   */
  synchronizerControllerUpdateManyCollections = (
    data: ApiUpdateManyCollectionsRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiUpdateManyCollectionsResponseDto, ApiBaseError>({
      path: `/synchronizer/collections/collections/updateMany`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
